import { ApiBaseService } from '../api-base-service';

export const Endpoint = {
    SYNCHRONIZE_CUSTOMER_DATA: '/login/synchronize-customer-data',
};

export class SynchronizationApiService extends ApiBaseService {
    constructor(context = '/delegate/synchronization/v1') {
        super(context);
    }

    async synchronizeCustomerData(): Promise<void> {
        return this.http.post(Endpoint.SYNCHRONIZE_CUSTOMER_DATA).then((response) => response.data);
    }
}
